import EmailTemplateType from "@/models/EmailTemplates/EmailTemplateType";
import EmailIntegrationTemplateDto from "@/models/EmailIntegrationTemplates/EmailIntegrationTemplateDto";

export default class EmailTemplateViewModel  {
	selectedEmailIntegrationTemplate: EmailIntegrationTemplateDto
	name = '';  
	type: EmailTemplateType;
	templateId = ''; 
	updatedAt: Date;
}